import request from '@/utils/request'

// 首页的接口
// 查询精品推荐类型
// 查询某个精品推荐下的类型
export function getFRecommendList(params) {
  return request({
    url: '/mall/mallmanage/index/getFRecommendList',
    method: 'post',
    params
  })
}

// 商品分类信息 查询首页侧边栏列表
// /mall/mallmanage/index/getStockClass post
export function getStockClass(params) {
  return request({
    url: '/mall/mallmanage/index/getStockClass',
    method: 'post',
    params
  })
}
// 商品分类信息 查询首页侧边栏列表  2022-10-25;左侧列表更新
// /mall/mallmanage/index/getCatalogSet post
export function getCatalogSet(params) {
  return request({
    url: '/mall/mallmanage/index/getCatalogSet',
    method: 'post',
    params
  })
}
// 查询首页，模块、轮播图、广告位
export function getIndexShopDecoration(params) {
  return request({
    url: '/mall/mallmanage/index/getIndexShopDecoration',
    method: 'post',
    params
  })
}
export function getRecommendData(params) {
  return request({
    url: '/mall/mallmanage/index/getFRecommendTypes',
    method: 'post',
    params
  })
}
export function getUser(data) {
  return request({
    url: '/mall/mallmanage/index/queryDemandUnitCustomerManager',
    method: 'get',
    data
  })
}
